export default class Buttons {
	constructor(button) {
		// let dataText = button.dataset.text;

		if( button.dataset.text == undefined ){
			button.dataset.text = button.innerText;
		}
		
	} 
}
